import React, { useContext } from 'react';
import { ToggleGroup } from './index';
import { analyticsTrackEvent } from '../../../../../../core/analytics';
import {
  CDP_BOOK_MODULE_ACTION,
  CDP_BOOK_MODULE_EVENT,
} from '../../../../../../core/analytics/events';
import { getDevice } from '../../../../../../core/util/device';
import { LocationContext } from '../../../../ContextProviders';
import dataTestIds from '~/test/test-ids';

type Props = {
  defaultSelectedToggleIndex?: number;
  handleInPersonClick: (...args: any[]) => any;
  handleVideoVisitClick: (...args: any[]) => any;
  headerTitle?: string;
  isVideoVisitSelected?: boolean;
};

const VisitTypeToggle = (props: Props) => {
  const {
    handleInPersonClick,
    handleVideoVisitClick,
    defaultSelectedToggleIndex,
    isVideoVisitSelected,
    headerTitle,
  } = props;
  const { location } = useContext(LocationContext);

  const toggleOptions = [
    {
      copy: 'Office visit',
      onClick: () => {
        handleInPersonClick();
        analyticsTrackEvent(CDP_BOOK_MODULE_EVENT, {
          action: CDP_BOOK_MODULE_ACTION.CLICK_OFFICE_VISIT,
          device: getDevice(),
          locationId: location.id,
          uclId: location.uclId,
        });
      },
      isSelected: !isVideoVisitSelected,
    },
    {
      copy: 'Video visit',
      onClick: () => {
        handleVideoVisitClick();
        analyticsTrackEvent(CDP_BOOK_MODULE_EVENT, {
          action: CDP_BOOK_MODULE_ACTION.CLICK_VIDEO_VISIT,
          device: getDevice(),
          locationId: location.id,
          uclId: location.uclId,
        });
      },
      isSelected: isVideoVisitSelected,
    },
  ];

  return (
    <ToggleGroup
      buttonTestIds={[dataTestIds.cdp.officeVisitToggle, dataTestIds.cdp.videoVisitToggle]}
      defaultSelectedToggleIndex={defaultSelectedToggleIndex}
      headerTitle={headerTitle}
      toggleOptions={toggleOptions}
    />
  );
};

export default VisitTypeToggle;
